import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import { ClearTokenRedirectLogin } from 'utils/general';
import CallIcon from 'assets/images/Dashboard/call.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import moment from 'moment';
import ArrowLeftIcon from 'assets/images/WithoutLogin/arrow-left.svg';
import { getPatientDetail } from 'store/getPatientDetail/getPatientDetailAction';
import Shimmer from 'components/commom/Shimmer';
import MuiBreadcrumbs from 'components/commom/MuiBreadcrumbs';
import DoctorPaietntAppointmentList from 'Pages/Doctor/DoctorPatient/DoctorPatientDetail/DoctorPatientAppointmentList';
import CommonToast from 'components/commom/CommonToast';

const PatientDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const { showToast } = CommonToast();
  const [patientDetail, setPatientDetail] = useState([]);

  const patientId = useSelector(
    (state) => state?.basicDetailsValueReducer?.patientId
  );

  const loading = useSelector(
    (state) => state?.getPatientDetailReducer?.loading
  );

  const breadcrumbsList = [
    {
      title: <FormattedMessage id="My patients" />,
      Link: '',
      isDisbale: true,
    },
    {
      title: <FormattedMessage id="Patient Details" />,
      Link: '',
      isDisbale: false,
    },
  ];

  useEffect(() => {
    getPatientDetailValue();
  }, []);

  const getPatientDetailValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setPatientDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPatientDetail(external, patientId));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <MuiBreadcrumbs size="12" list={breadcrumbsList} />
          <div className="mt-10">
            <Row className="bc-FFFFFF p-24 border-1 bColor-EFE3D7 m-0">
              <Col xs={12} md={12} className="p-0">
                <Stack direction="horizontal" gap={2} className="items-center">
                  <Image
                    src={ArrowLeftIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="cursor-pointer"
                    onClick={() => navigate(-1)}
                  />
                  {loading ? (
                    <Shimmer width="150px" height="20px" />
                  ) : (
                    <div className="fs-16 lh-16 fc-292D32 family_outfit_medium_500">
                      <FormattedMessage id="Patient" />
                      <span className="pl-2">
                        {patientDetail?.patient_details?.patient_id}
                      </span>
                    </div>
                  )}
                </Stack>
              </Col>

              <Col xs={12} md={12} className="mt-4 p-0 bColor-D6DDE6">
                <Row>
                  <Col md={6}>
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="flex items-start"
                    >
                      {loading ? (
                        <Shimmer
                          width="88px"
                          height="88px"
                          borderRadius="50%"
                        />
                      ) : (
                        <Image
                          src={
                            patientDetail?.patient_details?.profile_image !== ''
                              ? patientDetail?.patient_details?.profile_image
                              : DefaultImage
                          }
                          alt={'icon'}
                          style={{
                            height: '88px',
                            width: '88px',
                            borderRadius: '50%',
                          }}
                        />
                      )}
                      <div>
                        <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                          {loading ? (
                            <Shimmer width="150px" height="20px" />
                          ) : (
                            patientDetail?.patient_details?.patient_name
                          )}
                        </div>
                        <div>
                          <Stack
                            direction="horizontal"
                            gap={5}
                            className="items-center pt-12"
                          >
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              {loading ? (
                                <Shimmer width="250px" height="20px" />
                              ) : (
                                <>
                                  <Image src={CallIcon} alt="icon" />
                                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                                    {
                                      patientDetail?.patient_details
                                        ?.patient_phone
                                    }
                                  </div>
                                </>
                              )}
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              {loading ? (
                                <Shimmer width="250px" height="20px" />
                              ) : (
                                <>
                                  <Image src={MailIcon} alt="icon" />
                                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                                    {
                                      patientDetail?.patient_details
                                        ?.patient_email
                                    }
                                  </div>
                                </>
                              )}
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    </Stack>
                  </Col>
                  <Col md={6} className="flex justify-end items-center">
                    <div>
                      <div className="fs-14 lh-176 family_outfit_regular_400 fc-998A7B">
                        Joining Date
                      </div>
                      {loading ? (
                        <Shimmer width="100px" height="20px" />
                      ) : (
                        <div className="fs-16 pt-8 lh-201 family_outfit_regular_400 fc-202224">
                          {moment(
                            patientDetail?.patient_details?.consulted_on
                          ).format('DD MMM YYYY')}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <DoctorPaietntAppointmentList />
        </Col>
      </Row>
    </div>
  );
};

export default PatientDetail;
